import { UserMenuAction } from './toolbar.types';

/**
 * Definitions for the toolbar user context-menu items.
 * `labelKey` is a translation key — resolved by the component at runtime to
 * keep the const free of i18n service dependencies.
 * `name` is a `UserMenuAction` so the switch in `onUserMenuAction` can match
 * against typed enum members instead of magic strings.
 */
export const USER_MENU_DEFS: ReadonlyArray<{
  disabled?: boolean;
  divider?: boolean;
  icon?: string;
  labelKey: string;
  name: UserMenuAction;
}> = [
  {
    disabled: true,
    icon: 'settings',
    labelKey: 'toolbar.settings',
    name: UserMenuAction.Settings,
  },
  {
    icon: 'info',
    labelKey: 'toolbar.adroles',
    name: UserMenuAction.AdRoles,
  },
  { divider: true, labelKey: '', name: UserMenuAction.Divider },
  {
    icon: 'exit_to_app',
    labelKey: 'toolbar.logout',
    name: UserMenuAction.Logout,
  },
];

export const TOOLBAR_TEST_IDS = {
  helpLink: 'toolbar-help-link',
  languageButton: 'toolbar-language-button',
  languageMenu: 'toolbar-language-menu',
  notificationEmpty: 'toolbar-notification-empty',
  notificationError: 'toolbar-notification-error',
  notificationItem: 'toolbar-notification-item',
  notificationLoading: 'toolbar-notification-loading',
  notificationsButton: 'toolbar-notifications-button',
  notificationsMenu: 'toolbar-notifications-menu',
  plantButton: 'toolbar-plant-button',
  plantMenu: 'toolbar-plant-menu',
  userButton: 'toolbar-user-button',
  userMenu: 'toolbar-user-menu',
} as const;
